<template>
  <router-view></router-view>
</template>
<script>
import { defineComponent, reactive } from 'vue'
import { api } from '@/service/api'
import { setupFeedback } from '@/utils/feedback'
import { fetchProjectStypes } from '@/lib/stype'

export default defineComponent({
  setup() {
    setupFeedback()
    window.$store = reactive({
      projectList: [],
      currentProject: {},
      userInfo: {},
      projectStypes: [],
      alarmLevels: [],
      isApp: false, // 是否是通过app 或 小程序登录
      filterActive: false,
    })
    console.log('window.$store', window.$store)
    window.$fetchProjectStypes = fetchProjectStypes

    // 拉取告警等级公共配置
    window.$fetchAlarmLevels = async () => {
      const res = await api('base', 'get_base')
      if (res.code === 200 && Array.isArray(res.data)) {
        const alarmRecord = res.data.find((item) => item.title === '告警等级')
        if (alarmRecord) {
          window.$store.alarmLevels = Array.isArray(alarmRecord.value)
            ? alarmRecord.value
            : []
        }
      }
    }
  },
})
</script>
